import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import AccountDetail from '../AccountDetail';
import { EditButton } from '../EditButtonStyle.styles';
import FieldDetail from '../FieldDetail';

export default function SenderDetail({
  accountHolder,
  bank,
  accountNumber,
  fullAccountNumber,
  loading,
  hasEdit,
  handleEdit
}) {
  return (
    <Grid
      columnSpacing="8px"
      container
      pb={{ xs: '24px', lg: '56px' }}
      pt={{ xs: '24px', lg: '32px' }}
      px={{ xs: '24px', lg: '32px' }}
      rowSpacing={{ xs: '16px', lg: '32px' }}
    >
      <Grid
        item
        xs={12}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Text
            color="primary"
            size="xl"
            weight="medium"
          >
            From
          </Text>
          {hasEdit && (
            <EditButton
              color="info"
              onClick={handleEdit}
              size="small"
              variant="text"
            >
              Edit
            </EditButton>
          )}
        </Stack>
      </Grid>
      <FieldDetail
        label="Account holder"
        loading={loading}
        value={accountHolder}
      />
      <FieldDetail
        label="bank"
        loading={loading}
        value={bank}
      />
      <AccountDetail
        accountNumber={accountNumber}
        fullAccountNumber={fullAccountNumber}
        label="Account"
        loading={loading}
      />
    </Grid>
  );
}

SenderDetail.propTypes = {
  accountHolder: PropTypes.string,
  bank: PropTypes.string,
  accountNumber: PropTypes.string,
  fullAccountNumber: PropTypes.string,
  loading: PropTypes.bool,
  hasEdit: PropTypes.bool,
  handleEdit: PropTypes.func
};
